// Persists admin auth tokens + cached profile in localStorage. Bearer-token
// auth (matches the backend's Authorization: Bearer <token> middleware).
import type { Admin } from "../types/admin";

const ACCESS_KEY = "safiri.admin.accessToken";
const REFRESH_KEY = "safiri.admin.refreshToken";
const PROFILE_KEY = "safiri.admin.profile";

export const tokenStore = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  setTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_KEY, accessToken);
    localStorage.setItem(REFRESH_KEY, refreshToken);
  },
  setAccess(accessToken: string): void {
    localStorage.setItem(ACCESS_KEY, accessToken);
  },
  getProfile(): Admin | null {
    const raw = localStorage.getItem(PROFILE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as Admin;
    } catch {
      return null;
    }
  },
  setProfile(admin: Admin): void {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(admin));
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(PROFILE_KEY);
  },
};
